module.exports = __webpack_public_path__ + "static/media/MarceloNisinman.4347cf9d.jpg";